import React from 'react'

function NewsItem() {
  return (
    <div className='newContainer'>
      <div className='new'>
        <div className='img-container'>
            <img alt='' src="https://static.remove.bg/sample-gallery/graphics/bird-thumbnail.jpg"/>
        </div>
        <div className='newtext'>
            <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
        </div>
      </div>
    </div>
  )
}

export default NewsItem
